export default __webpack_public_path__ + "static/logo_mycawan_by_netresto_horizontal_bleu-12452d7ef720d147fcebe3c8e223715e.svg";